import React from 'react';
import { Field } from 'redux-form';
import { RadioField } from 'redux-form-antd';
import { Button, Col, Row, Spin, Select } from 'antd';
import FormValueSelector from '../../../containers/FormValueSelector';
import { SelectField } from '../../../services/ant-redux';

const BeaconTab = ({
  fetchBeacon,
  data,
  handleChange,
  fetching,
  value,
  uploadBeacons,
  handleSubmit,
  submitting,
}) => (
  <div>
    <form onSubmit={handleSubmit}>
      <FormValueSelector fieldName="method">
        {type =>
          (type === 'bulk' && (
            <Field
              name="beacons"
              component={SelectField}
              parse={a => {
                if (a && Array.isArray(a)) {
                  return a
                    .map(b => (!Number.isNaN(parseInt(b, 10)) ? parseInt(b, 10) : null))
                    .filter(Number);
                }

                return a && !Number.isNaN(parseInt(a, 10)) ? parseInt(a, 10) : null;
              }}
              mode="tags"
              tokenSeparators={[',']}
              placeholder="Enter IDs comma separated (1,2,3)"
            />
          )) ||
          ((!type || type === 'search') && (
            <Field
              mode="multiple"
              showSearch
              value={value}
              notFoundContent={fetching ? <Spin size="small" /> : null}
              filterOption={false}
              onSearch={fetchBeacon}
              onChange={handleChange}
              name="beacons"
              component={SelectField}
              placeholder="Search Beacons"
            >
              {data.map(d => (
                <Select.Option key={d.value}>{d.text}</Select.Option>
              ))}
            </Field>
          ))
        }
      </FormValueSelector>

      <Row type="flex" align="top" justify="space-between">
        <Col>
          <Button onClick={handleSubmit} loading={submitting}>
            Include
          </Button>
        </Col>
        <Col>
          <Field
            name="method"
            id="method"
            component={RadioField}
            options={[
              { label: 'Beacon Search', value: 'search' },
              { label: 'Bulk Add', value: 'bulk' },
            ]}
          />
        </Col>
      </Row>
    </form>
  </div>
);

export default BeaconTab;
